module.exports = __webpack_public_path__ + "static/img/class.b12263d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class.jpg
// module id = wOde
// module chunks = 1